"use client";
import LocaleLink from "@/components/locale-link";
import { ChevronLeft } from "lucide-react";
import ForgotPasswordForm from "@/components/forms/auth/forgot-password/forgot-password-form";
import { useEffect, useState } from "react";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/client";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";

interface ForgotPasswordProps {
    radiusStyle : any;
}

function ForgotPassword(props: ForgotPasswordProps) {
    const { radiusStyle } = props;
    const { t } = useTranslation();
    const [step, setStep] = useState("forgot-password");
    const [memberId, setMemberId] = useState("");

    useEffect(() => {}, [memberId]);

    const handleForgotPasswordUpdate = (success: boolean, memberId: string) => {
        if (success) {
            setStep("forgot-password-success");
            setMemberId(memberId);
        }
    };
    const colorStyle = useContext(ColorStyleContext);

    const tabTriggerCn = "data-[state=active]:bg-white data-[state=active]:shadow-none data-[state=active]:text-c2";
    return (
        <div className="w-full px-4 md:px-8 flex flex-col justify-center items-center gap-6">
            {step === "forgot-password" && (
                <>
                    <h1 className="font-normal text-2xl md:text-3xl" style={{ color: colorStyle?.headingMain || "#254b7c"}}>
                        {t("forgot_password.title")}
                    </h1>
                    <div className="w-full max-w-[370px] xs:max-w-[420px] sm:max-w-[520px] shadow-sm border rounded-[20px] overflow-clip bg-white">
                        <ForgotPasswordForm forgotPasswordSuccess={handleForgotPasswordUpdate} radiusStyle={radiusStyle}/>
                    </div>
                    <LocaleLink href="/signin" className="flex justify-center items-center dynamic-color"  style={{
                        "--dynamic-color": colorStyle?.link || "#009eca",
                        "--dynamic-hover-color": colorStyle?.linkHover || "#254b7c",
                    } as React.CSSProperties}>
                        <ChevronLeft />
                        <h4>{t("forgot_password.forgot_btn_home")}</h4>
                    </LocaleLink>
                </>
            )}

            {step === "forgot-password-success" && (
                <>
                    <Image className="mr-2" src={"/assets/icons/check.svg"} alt={""} width={100} height={100} />
                    <h1 className="font-normal text-2xl md:text-3xl" style={{ color: colorStyle?.headingMain || "#254b7c"}}>
                        {t("set_password_success_title")}
                    </h1>
                    <p className="font-light"  style={{ color : colorStyle?.text || "#3d3d3d"}}>
                        {t("set_password_success_message")}
                        {/* {t("set_password_success_message", {
                            memberId: `${memberId.toUpperCase()}`,
                        })} */}
                    </p>
                    <div className="w-full flex flex-col items-center justify-center">
                        <Link
                            id="back-to-login-btn"
                            className="max-w-[260px] px-6 h-[48px] dynamic-bg dynamic-color flex items-center justify-center text-lg font-normal"
                            href="/signin"
                            style={
                                {
                                    "--dynamic-bg": colorStyle?.buttonBgNormal || "#009eca",
                                    "--dynamic-hover-bg": colorStyle?.buttonBgHover || "#254b7c",
                                    "--dynamic-color": colorStyle?.buttonTextNormal || "#ffffff",
                                    "--dynamic-hover-color": colorStyle?.buttonTextHover || "#ffffff",
                                    "--dynamic-focus-color": colorStyle?.buttonTextHover || "#ffffff",
                                    borderTopLeftRadius: (radiusStyle as any)?.buttonRadiusTopLeft ?? "6px",
                                    borderTopRightRadius: (radiusStyle as any)?.buttonRadiusTopRight ?? "6px",
                                    borderBottomLeftRadius: (radiusStyle as any)?.buttonRadiusBottomLeft ?? "6px",
                                    borderBottomRightRadius: (radiusStyle as any)?.buttonRadiusBottomRight ?? "6px",
                                } as React.CSSProperties
                            }>
                            {t("login.login_btn_back_to_login")}
                        </Link>
                    </div>
                </>
            )}
        </div>
    );
}

export default ForgotPassword;
